export default __webpack_public_path__ + "static/media/JetSetter_159x150.00503a11.png";